import { createTranslations } from '@momentum/i18n';
import { commonEnTranslations } from './common.en';

export const commonHeTranslations = createTranslations(commonEnTranslations, {
  fullPageShell: {
    progressAriaLabel: 'שלב {{step}} מתוך {{total}}',
  },

  // Common
  language: 'שפה',
  selectYourPreferredLanguage: 'בחר את השפה המועדפת עליך',
  today: 'היום',
  yesterday: 'אתמול',
  anotherDate: 'תאריך אחר',
  clear: 'נקה',
  close: 'סגור',
  enter: 'יש להכניס',

  // Pages
  myInteractions: 'האינטראקציות שלי',
  myInteractionsDescription:
    'כל האינטראקציות שלך: I See You, I Need You, ו-I Learn',
  indexRoute: 'דף ראשי',
  youAreSignedIn: 'את/ה מחובר',
  youAreSignedOut: 'את/ה מנותק',
  errorLoadingData: 'שגיאה בטעינת עובדים, מטרות או ערכי חברה:',
  errorLoadingEmployees: 'שגיאה בטעינת עובדים:',
  loadingData: 'טוען עובדים, מטרות וערכי חברה...',
  loadingDebrief: 'טוען דיברי׳ף...',
  loadingFeedback: 'טוען משוב...',
  loadingPraise: 'טוען I See You...',
  notFound: (type: string) => `${type} לא נמצא`,
  goBack: 'חזור',
  backToInteractions: 'חזרה לאינטראקציות',
  selected: 'נבחר:',
  usageExamples: 'דוגמאות שימוש',
  chooseListDemo: 'דמו של רכיב בחירת רשימה',

  // Date picker
  selectDate: 'בחר תאריך',
  pickDate: 'בחר תאריך',
  pickDateRange: 'בחר טווח תאריכים',
  shortFormat: 'פורמט קצר',
  shortDateFormat: 'פורמט תאריך קצר',
  selectedDate: 'תאריך נבחר',

  // Choose list
  chooseOption: 'בחר אפשרות',
  selectOption: 'בחר אחת מהאפשרויות הזמינות למטה',
  selectedOption: 'אפשרות נבחרת',

  // Demo page
  componentDemos: 'הדגמות רכיבים',
  componentDemosDescription: 'הדגמות אינטראקטיביות של רכיבי הקלט שלנו',
  datePickerInput: 'קלט בחירת תאריך',
  datePickerDescription: 'בחר כל תאריך מהלוח שנה',
  chooseListInput: 'קלט בחירת רשימה',
  chooseListDescription: 'בחר אחת מהאפשרויות הזמינות למטה',

  // Options
  option1: 'אפשרות 1',
  option1Description: 'האפשרות הראשונה עם תיאור',
  option2: 'אפשרות 2',
  option2Description: 'האפשרות השנייה עם תיאור',
  option3: 'אפשרות 3',
  option3Description: 'האפשרות השלישית עם תיאור',
  option4: 'אפשרות 4',
  option4Description: 'האפשרות הרביעית עם תיאור',
  option5: 'אפשרות 5',
  option5Description: 'האפשרות החמישית עם תיאור',

  // Interaction type selection
  selectInteractionType: 'בחר סוג אינטראקציה',
  selectInteractionTypeDescription: 'בחר האם אתה רוצה לשלוח הערכה או משוב',
  sendInteractionTo: 'שלח אינטראקציה אל',
  chooseInteractionType: 'בחר איך ברצונך לתקשר',
  chooseHowToInteractWith: 'בחר איך ברצונך לתקשר עם',

  // Employee Roles - maps Role enum values to display names
  employeeRoles: {
    systemAdmin: 'מנהל מערכת',
    admin: 'מנהל',
    manager: 'מנהל צוות',
    employee: 'עובד',
  },

  // Platform Restriction
  platformRestriction: {
    desktopOnly: 'הדף זמין רק במחשב',
    mobileOnly: 'הדף זמין רק בנייד',
    switchTo: 'אנא עבור ל-{{platform}} כדי לגשת לדף זה',
    returnHome: 'חזור לדף הבית',
  },

  // Dashboard
  dashboard: 'לוח בקרה',
  currentMonth: 'החודש הנוכחי',
  quickActions: 'פעולות מהירות',
  createFeedback: 'I Need You',
  createFeedbackDescription: 'שתף משוב בונה',
  createPraise: 'I See You',
  createPraiseDescription: 'הכר בעבודה מצוינת',
  createDebrief: 'I Learn',
  createDebriefDescription: 'קבע דיברי׳ף צוות',
  praiseReview: 'סקירת I See You',
  feedbackReview: 'סקירת I Need You',

  // Pending Feedback
  pendingFeedback: 'משוב ממתין',
  noPendingFeedback: 'אין פריטי משוב ממתינים',
  activeDuration: 'משך פעיל',
  actions: 'פעולות',
  creator: 'בעלים',
  receiver: 'מקבל',
  loading: 'טוען',
  error: 'שגיאה',
  day: 'יום',
  days: 'ימים',

  // Open Blockages
  openBlockages: 'חסימות פתוחות',
  blockagesReceived: 'חסימות שקיבלת',
  blockageReceived: 'חסימה שקיבלת',
  noBlockages: 'אין חסימות פתוחות',
  noOpenBlockages: 'אין חסימות פתוחות',
  allClear: 'הכל נקי! אין לך חסימות ממתינות.',
  viewAllBlockages: 'צפה בכל החסימות',
  reviewBlockages: 'סקור חסימות',
  requiresAttention: 'דורש תשומת לב',

  // Intera Tasks
  actionPlans: 'משימות INTERA',
  taskName: 'שם המשימה',
  dueDate: 'תאריך יעד',
  linkedInteraction: 'אינטראקציה מקושרת',
  noActionPlans: 'אין משימות INTERA',
  takeAction: 'נקוט פעולה',
  dueSoon: 'משימה שצריכה להתבצע בשבוע הקרוב',
  overdue: 'משימה באיחור',

  // Dashboard Header
  welcomeBack: (name: string) => `ברוכים השבים, ${name}`,
  dashboardSubtitle: 'הנה מה שקורה עם הצוות שלך',

  // Navigation
  signOut: 'התנתק',
  home: 'בית',
  iSeeYou: 'I See You',
  iNeedYou: 'I Need You',
  iLearn: 'I Learn',
  goals: 'יעדים',
  knowledge: 'ידע ארגוני',
  dealIntelligence: 'Deal Intelligence',
  kci: 'KCI',
  kciRadar: 'KCI Radar',
  interactions: 'אינטראקציות',
  oneOnOne: '1:1',
  profile: 'פרופיל',
  employeeHierarchy: 'היררכיית עובדים',

  // Employee Hierarchy page
  employeeHierarchyPageTitle: 'היררכיית עובדים',
  employeeHierarchyCompany: 'חברה',
  employeeHierarchySelectCompany: 'בחר חברה',
  employeeHierarchySelectCompanyHint:
    'בחר חברה כדי לצפות בהיררכיית העובדים שלה.',
  employeeHierarchyLoading: 'טוען היררכיה...',
  employeeHierarchyNoEmployees: 'לא נמצאו עובדים בחברה זו.',
  employeeHierarchyRoleSystemAdmin: 'מנהל מערכת',
  employeeHierarchyRoleAdmin: 'מנהל',
  employeeHierarchyRoleManager: 'מנהל צוות',
  employeeHierarchyRoleEmployee: 'עובד',

  // Latest Interactions
  loadingInteractions: 'טוען אינטראקציות...',
  noInteractionsFound: 'לא נמצאו אינטראקציות',

  // Open Blockages Banner
  oneOpenBlockage: 'חסימה פתוחה אחת',
  multipleOpenBlockages: (count: number) => `${count} חסימות פתוחות`,
  openBlockagesDescription: 'סקור וטפל בפריטים אלה',
  review: 'צפה',
});
